

/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require( './bootstrap' );

// Import the Store and Router
import store from "./../store/grotecStore";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue( {
    el: '#collection',

    data() {
        return {
            transitionName: 'slide-left',
        }
    },

    watch: {
        '$route' ( to, from ) {
            const toDepth = to.path.split( '/' ).length;
            const fromDepth = from.path.split( '/' ).length;
            this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        },
    },

    store
} );
